import styled from "styled-components"
import { Flex, FlexProps } from "rebass"

const ModalContainer = styled<FlexProps>(Flex)`
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`

export default ModalContainer
